import { render, staticRenderFns } from "./BeforeYouGetStarted.vue?vue&type=template&id=06a5177f&scoped=true"
import script from "./BeforeYouGetStarted.vue?vue&type=script&lang=ts"
export * from "./BeforeYouGetStarted.vue?vue&type=script&lang=ts"
import style0 from "./BeforeYouGetStarted.vue?vue&type=style&index=0&id=06a5177f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a5177f",
  null
  
)

export default component.exports